import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { darken, transparentize } from 'polished';
import PropTypes from 'prop-types';
import { cobaltBlue, whiteSmoke, white, poppyRed, steel, iron } from '../../styles/colors';
var BASE_SIZE = 32;
var SMALL_SIZE = 24;
var LARGE_SIZE = 40;
export var FONT_WEIGHT = 600;
export function textColor(color) {
  switch (color) {
    case 'destroy':
      return poppyRed;

    case 'secondary':
      return steel;

    default:
      return cobaltBlue;
  }
}

function withIconButtonSize(size) {
  switch (size) {
    case 'large':
      return LARGE_SIZE;

    case 'small':
      return SMALL_SIZE;

    default:
      return BASE_SIZE;
  }
}

export function getButtonType(_ref) {
  var submit = _ref.submit,
      reset = _ref.reset;
  if (submit || reset) return submit ? 'submit' : 'reset';
  return 'button';
}
export function iconSize(size) {
  switch (size) {
    case 'small':
      return size;

    default:
      return 'medium';
  }
}
export function iconColor(type, color) {
  switch (type) {
    case 'primary':
    case 'destroy':
    case 'dark':
      return white;

    case 'secondary':
    case 'white':
      return cobaltBlue;

    case 'text':
      return textColor(color);

    default:
      return steel;
  }
}
export function buttonTextColor(type, colorType) {
  switch (type) {
    case 'secondary':
    case 'white':
      return cobaltBlue;

    case 'text':
      return textColor(colorType);

    default:
      return white;
  }
}
export function buttonBackgroundColor(type) {
  switch (type) {
    case 'secondary':
      return whiteSmoke;

    case 'text':
      return 'transparent';

    case 'destroy':
      return poppyRed;

    case 'dark':
      return '#3c4349';

    case 'white':
      return white;

    case 'primary':
    default:
      return cobaltBlue;
  }
}
export function buttonHoverStyle(type) {
  switch (type) {
    case 'secondary':
      return {
        backgroundColor: darken(0.04, whiteSmoke),
        svg: {
          color: cobaltBlue
        }
      };

    case 'text':
      return {
        backgroundColor: transparentize(0.8, iron)
      };

    case 'destroy':
      return {
        backgroundColor: darken(0.12, poppyRed)
      };

    case 'dark':
      return {
        backgroundColor: darken(0.04, '#3c4349')
      };

    case 'white':
      return {
        color: darken(0.12, cobaltBlue)
      };

    case 'primary':
    default:
      return {
        backgroundColor: darken(0.12, cobaltBlue)
      };
  }
}
export function buttonActiveStyle(type) {
  switch (type) {
    case 'secondary':
      return {
        backgroundColor: darken(0.08, whiteSmoke),
        svg: {
          color: cobaltBlue
        }
      };

    case 'text':
      return {
        backgroundColor: transparentize(0.6, iron)
      };

    case 'destroy':
      return {
        backgroundColor: darken(0.24, poppyRed)
      };

    case 'dark':
      return {
        backgroundColor: darken(0.08, '#3c4349')
      };

    case 'white':
      return {
        color: darken(0.24, cobaltBlue)
      };

    case 'primary':
    default:
      return {
        backgroundColor: darken(0.24, cobaltBlue)
      };
  }
}
export function buttonDisabledStyle(type) {
  if (type === 'primary') {
    return {
      backgroundColor: transparentize(0.4, cobaltBlue)
    };
  }

  return {
    opacity: 0.4
  };
}
export function buttonFontSize(size) {
  if (size === 'small') {
    return 12;
  }

  return 14;
}

var ButtonBase = function ButtonBase(_ref2) {
  var fullheight = _ref2.fullheight,
      fullwidth = _ref2.fullwidth,
      size = _ref2.size,
      typeStyle = _ref2.typeStyle,
      withIcon = _ref2.withIcon;
  var sizeStyle = {
    height: "".concat(BASE_SIZE, "px"),
    padding: '0 16px',
    lineHeight: 1
  };

  if (size === 'large') {
    sizeStyle.height = "".concat(LARGE_SIZE, "px");
  } else if (size === 'small') {
    sizeStyle.height = "".concat(SMALL_SIZE, "px");
    sizeStyle.padding = '0 12px';
  }

  if (withIcon) {
    sizeStyle.width = "".concat(withIconButtonSize(size), "px");
    sizeStyle.padding = 0;
  }

  if (fullwidth) {
    sizeStyle.width = '100%';
  }

  if (fullheight) {
    sizeStyle.height = '100%';
    sizeStyle.lineHeight = '100%';
  }

  return _objectSpread({
    border: 0,
    borderRadius: '3px'
  }, sizeStyle, {
    position: 'relative',
    backgroundColor: buttonBackgroundColor(typeStyle)
  });
};

export default ButtonBase;
export var buttonPropTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(['primary', 'secondary', 'destroy']),
  fullwidth: PropTypes.bool,
  fullheight: PropTypes.bool,
  icon: PropTypes.string,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  loadingText: PropTypes.string,
  reset: PropTypes.bool,
  submit: PropTypes.bool,
  type: PropTypes.oneOf(['primary', 'secondary', 'text', 'white', 'destroy', 'dark'])
};
export var buttonDefaultProps = {
  children: null,
  color: 'primary',
  fullwidth: false,
  fullheight: false,
  icon: null,
  isLoading: false,
  size: null,
  loadingText: '',
  reset: false,
  submit: false,
  type: 'primary'
};